<template>
  <div class="list-section">
    <van-pull-refresh
      :value="refreshing"
      @input="$emit('update:refreshing', $event)"
      @refresh="$emit('refresh')"
    >
      <van-list
        :loading="loading"
        @input="$emit('update:loading', $event)"
        :finished="finished"
        :finished-text="items.length === 0 ? '' : '没有更多数据了'"
        :immediate-check="false"
        class="alarm-list"
        @load="$emit('load')"
      >
        <div v-if="items.length === 0 && finished" class="empty-alarm">
          <div class="empty-icon">
            <van-icon name="search" size="56" color="#BBB" />
          </div>
          <div class="empty-text">暂无{{ status === '0' ? '未处理' : '已处理' }}告警</div>
          <div class="empty-subtext">调整筛选条件后重试</div>
        </div>

        <AlarmCard
          v-for="(item, index) in items"
          :key="item.id || index"
          :item="item"
          :status="status"
          @open-handle="$emit('open-handle', item)"
          @show-detail="$emit('show-detail', item)"
        />
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import AlarmCard from '@/components/alarm/AlarmCard';

// 告警列表：alarmInfo / mulAlarmInfo 共用，列表状态仍由页面持有
export default {
  name: 'AlarmListPanel',
  components: { AlarmCard },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    // '0' 待处理 / '1' 已处理
    status: {
      type: String,
      default: '0'
    },
    loading: Boolean,
    finished: Boolean,
    refreshing: Boolean
  }
  // van-list / van-pull-refresh 的 v-model 拆成 prop + input 事件，值变化通过 .sync 回传给页面
};
</script>

<style lang="less" scoped>
.list-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border-radius: 14px;
  padding: 0 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  ::v-deep .van-pull-refresh {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  ::v-deep .van-pull-refresh__track {
    flex: 1;
    min-height: 0;
  }
}

/* 列表区高度由 flex 分配，不再用 JS 测量高度 */
.alarm-list {
  height: 100%;
  min-height: 0;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.empty-alarm {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;

  .empty-icon {
    margin-bottom: 16px;
  }

  .empty-text {
    font-size: 30px;
    font-weight: 600;
    color: #64748B;
    margin-bottom: 8px;
  }

  .empty-subtext {
    font-size: 26px;
    color: #909399;
  }
}
</style>
